"use client";
import { environments } from "@/lib/config";
import { buildWsUrl } from "@/lib/utils/build-ws-url";
import { WebSocketClient } from "@/lib/utils/websocket-client";
// no local store; rely on server counts and query invalidation
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { notificationKeys } from "@/hooks/notification-hooks/notificationKeys";

interface NotificationProviderProps {
  userId: string;
  children: React.ReactNode;
}

export default function NotificationProvider({
  userId,
  children,
}: NotificationProviderProps) {
  const socketConnection = environments.socketConnection;
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!userId) return;

    //const wsUrl = buildWsUrl(socketConnection, `/ws/notifications`);
    const wsUrl = buildWsUrl(socketConnection, `/ws/notifications`);
    const ws = new WebSocketClient(wsUrl, {
      reconnect: true,
      idleTimeoutMs: 5 * 60 * 1000,
      // heartbeatIntervalMs: 1 * 60 * 1000,
    });

    ws.onMessage((msg) => {
      try {
        console.warn("Notification:", msg);
        // If backend sends a notification payload, invalidate notification queries
        // so UI lists and counts refresh. We rely on the server-provided counts
        // so there's no local store increment here.
        queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      } catch (err) {
        console.error("Error handling notification message:", err);
      }
    });

    return () => ws.close();
  }, [userId]);

  return <>{children}</>;
}
